<template>
  <div class="header-item">
    <component
      v-for="(item, index) in itemsComp"
      :key="index"
      :is="item.component"
      v-bind="item.props"
      v-on="item.listeners || {}"
    >
      <template v-for="(child, slot) of item.children || {}" v-slot:[slot]>
        <HeaderItem :key="slot" :items="child" />
      </template>
    </component>
  </div>
</template>

<script>
import { DropdownComponent } from 'vue-elder-dropdown'
import Actions from '@/components/Actions'
import Preview from '@/components/Preview'

let filter = f => {
  if (!('condition' in f)) return true
  if (typeof f.condition === 'function') return f.condition()
  return f.condition
}

export default {
  name: 'HeaderItem',
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    itemsComp() {
      if (!this.items) return []
      return (this.items instanceof Array ? this.items : [this.items]).filter(item => filter(item))
    },
  },
  components: {
    DropdownComponent,
    Actions,
    Preview,
  },
}
</script>

<style lang="scss" scoped></style>
